var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStopIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 9,
  height: 9,
  x: 3.5,
  y: 3.5,
  stroke: "currentColor",
  rx: 1.5
})));
export default SvgStopIcon;